import React from "react";

const Info = ({ style, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      style={style}
      stroke="currentColor"
      {...props}
    >
      <g id="Raggruppa_609" transform="translate(-468 -466.26)">
        <g id="Raggruppa_567" transform="translate(-881 77.26)">
          <g id="g1347" transform="translate(1348 97.35)">
            <path
              id="path1340"
              d="M12.476,299.65A1.476,1.476,0,0,0,11,301.126v10.33a1.476,1.476,0,1,0,2.951,0v-10.33A1.476,1.476,0,0,0,12.476,299.65Z"
              transform="translate(4.281 3.33)"
              fill="#1a1a1a"
            />
            <path
              id="path1342"
              d="M13.951,298.126a1.476,1.476,0,1,1-1.476-1.476A1.476,1.476,0,0,1,13.951,298.126Z"
              transform="translate(4.281 1.902)"
              fill="#1a1a1a"
            />
          </g>
        </g>
        <g id="Raggruppa_602" transform="translate(-124 71.776)">
          <g
            id="Ellisse_19"
            transform="translate(594 396.484)"
            fill="none"
            strokeWidth="2"
          >
            <circle cx="14" cy="14" r="14" stroke="none" />
            <circle cx="14" cy="14" r="13" fill="none" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Info;
